module.exports = __webpack_public_path__ + "static/media/si_2.b2ebdcb3.JPG";